module.exports = __webpack_public_path__ + "img/Bankston.5fc838c4.svg";